import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { darken } from '@material-ui/core/styles/colorManipulator'

const useStyles = makeStyles((theme) => ({
  contentWrapperWithGradient: {
    background:
      'linear-gradient(to bottom, ' +
      theme.palette.primary.main +
      ' 0%, ' +
      darken(theme.palette.primary.main, 0.5) +
      ' 100%)',
    color: theme.palette.text.primary,
    '&.boxed': {
      maxWidth: 1280,
      margin: '0 auto',
      boxShadow: theme.shadows[3],
    },
  },
}))

const CommonBackground = (props) => {
  const classes = useStyles()
  return (
    <div className="overflow-auto flex flex-1 flex-col">
      <div
        className={clsx(
          classes.contentWrapperWithGradient,
          'flex flex-col flex-1 flex-shrink-0 sm:p-24 md:p-0 p-0',
        )}
      >
        {props.children}
      </div>
    </div>
  )
}

export default CommonBackground
